import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EnvIndicatorComponent } from './env-indicator.component';



@NgModule({
    declarations: [
        EnvIndicatorComponent
    ],
    imports: [
        CommonModule,
        DragDropModule
    ],
    exports: [
        EnvIndicatorComponent
    ]
})
export class EnvIndicatorModule { }
